module.exports = __webpack_public_path__ + "static/media/arrowDown.0078e81c.svg";